<template>
    <div class="">
        <div class="empleo">
            <div class="">
                <div class="tipo">
                    <span class="texto">{{ item.tipo }}</span>
                </div>

                <div class="mt-2">
                    <a :href="'https://bolsadetrabajo.santiago.gob.mx/empleo/' + item.slug + utm" class="titulo" tabindex="0" role="link">{{ item.nombre }}</a>
                    <p class="sueldo">${{ $filters.getMoneyFormat(item.sueldo) }} mensual</p>
                    <p class="descripcion">{{ $filters.truncate(item.descripcion_txt, 200, '...') }}</p>
                </div>
            </div>

            <div class="boton">
                <a class="boton-secundario boton-flecha" :href="'https://bolsadetrabajo.santiago.gob.mx/empleo/' + item.slug + utm">Ver Empleo</a>
            </div>
        </div>
    </div>
</template>
<style scoped>
.empleo {
    border: 1px solid #72b2bd;
    padding: 15px;
    font-size: 1rem;
    line-height: 1.1em;
    border-radius: 10px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.tipo {
    text-align: right;
}

.tipo .texto {
    font-size: .8rem;
    border-bottom: 1px solid #bfbfbf;
}

.titulo {
    font-size: 1.3rem;
    color: #000;
    font-weight: 600;
    display: block;
    line-height: 1.1em;
    text-transform: uppercase;
}

.sueldo {
    color: #398894;
    margin-top: 1px;
    font-weight: bold;
}

.descripcion {
    font-size: .9rem;
    text-transform: lowercase;
    line-height: 1.3em;
}

.boton {
    margin-top: 15px;
    margin-bottom: 5px;
    text-align: center;
}

.boton a {
    padding: 9px 9px 9px 9px;
    font-size: .9em;
    background-color: #85d7e5;
    color: #000;
    border: 0;
}
</style>

<script>
export default {
    props: {
        item: Object,
    },
    data() {
        return {
            utm: "?utm_source=Santiago%20Website&utm_medium=web&utm_campaign=Bolsa%20de%20Trabajo",
        }
    },
}
</script>
